.chip {
  &Root {
    height: 2.5rem;
    margin: 0.2rem;
  }
  &Avatar {
    height: 1.8rem !important;
    width: 1.8rem !important;
  }
  &DeleteIcon {
    height: 1.8rem !important;
    width: 1.8rem !important;
  }
}
